import React from "react";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { Paper, Breadcrumbs, Link, Grid, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Styles from "../PMSComponents/alertModule/styles/main.module.css";
import { useLocation } from "react-router-dom";
import { ls } from "../../variables";
import Style from "./Styles/moduleLayout.module.css";
import ProfileIcon from "../../images/ProfileIcon.svg";
import { DataGrid, renderActionsCell } from "@mui/x-data-grid";
import UserTypeIcon from "../../images/UserTypeIcon.svg"
import UsernameIcon from "../../images/UsernameIcon.svg"
import EmailIcon from "../../images/EmailIcon.svg"
const Profile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state;
  const userType = data.userType;

  const user = {
    userName	: ls.get("userName"),
    apmiiname	: ls.get("apmiiname"),
    pmsName: ls.get("pmsName"),
    pmsCode: ls.get("pmsCode"),
    email: ls.get("email"),
    userType: ls.get("userType"),
  };

  const fundAccess = ls.get("fundAccess");
// console.log("FUNDACCESS>>>>>",fundAccess["Alert Processing"][0].code);
  const rows = [
    {
      id: 1,
      reportType: "ALERT",
      PMS: fundAccess['Alert Processing']?.map(item => item.code)
    },
    {
      id: 2,
      reportType: "CMM",
      PMS: fundAccess['CMM']?.map(item => item.code)
    },
  ];
  const columns = [
    {
      field: "id",
      headerName: "id",
      editable: false,
      flex: 0.5,
      minWidth: 50,
      align: "center",
      headerAlign: "center",

    },
    {
      field: "reportType", headerName: "Report Type", minWidth: 100, flex: 0.5, fontSize: "0.5rem", renderCell: (params) => {

        return <Grid sx={{ fontWeight: "700", fontSize: { md: "0.8rem", lg: "0.9rem", xl: "1.3rem" } }}>{params.value}</Grid >
      }, align: "center", headerAlign: "center"
    },
    { field: "PMS", headerName: "PMS", width: 400, flex: 2 },
  ];

  const profileObj = [
    {
      header: "User Type",
      value: user?.userType,
      icon: UserTypeIcon,
    },
    {
      header: "Username",
      value: user?.userName,
      icon: UsernameIcon,
    },
    {
      header: "Email ID",
      value: user?.email,
      icon: EmailIcon,
    },
  ];
  return (
    <>
      <div
        className={Styles.FullBody}
        style={{ overflow: "hidden", height: "95%" }}
      >
        <Grid className={Styles.navBody} >
          <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb">
            <Link
              underline="hover"
              color="inherit"
              onClick={() => user.userType==='APMII'?navigate("/app/Analytics"): navigate("/app/welcome")}
            >
             {user.userType==='APMII'?"Analytics" : "Welcome"}
            </Link>
            <Link underline="hover" color="inherit">
              {" "}
              Profile Page{" "}
            </Link>
          </Breadcrumbs>
        </Grid>

        {user.userType == "SEBI" ? (
          <Grid container xs={12} className={Style.profileContainer}>
            <Grid item xs={11} className={Style.profileHeader}>
              {" "}
              <img src={ProfileIcon} />
              User Profile
            </Grid>
            <Grid item xs={11} className={Style.profileBody}>
              <Grid item xs={12} className={Style.profileInfo}>
                {profileObj?.map((val, key) => {
                  return (
                    <Grid item xs={val.header == "User Type" ? 3 : val.header == "Username" ? 3.5 : 5} className={Style.infoHeader} key={key}>
                      <div
                        style={{
                          fontSize: "0.8rem",
                          color: "#153064",
                          fontWeight: "700",
                        }}
                      >
                        {val.header}
                      </div>
                      <Grid
                        sx={{
                          width: "100%",
                          border: "1.5px solid #D2D5DA",
                          borderRadius: "0.5rem",
                          paddingLeft: "0.5rem",
                          paddingTop: "0.5rem",
                          paddingBottom: "0.5rem",
                          color: "#153064",
                          overflow: "auto",
                          scrollbarWidth: "none",
                          fontSize: { xs: "0.5rem", sm: "0.6rem", md: "0.7rem", lg: "0.8rem", xl: "1.2rem" },
                          background: "#ffffff",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          paddingRight: "0.8rem"
                        }}
                      >
                        {val.value}
                        <img src={val.icon} />
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
            <Grid item xs={11} className={Style.profileTable}>
              <DataGrid
                rows={rows}
                columns={columns}
                autoHeight
                disableColumnMenu
                disableColumnResize
                disableColumnReorder={true}
                disableColumnSorting
                hideFooter
                disableRowSelectionOnClick
                columnVisibilityModel={{
                  id: false
                }}
                getRowHeight={() => "auto"}
                sx={{
                  background: "#ffffff",
                  color: "#000000",
                  border: "1px solid #D0CBCB !important",
                  "& .MuiDataGrid-columnSeparator--sideRight": { display: "none" },
                  "& .MuiDataGrid-cell": {
                    border: "1px solid #D0CBCB ", whiteSpace: "normal",
                    wordBreak: "break-word", minHeight: "2.2rem", alignItems: "center", display: "flex", paddingLeft: "0.5rem", fontSize: { xs: "0.5rem", md: "0.7rem", xl: "1rem" }, paddingTop: "0.2rem", paddingBottom: "0.2rem"
                  },
                  "& .MuiDataGrid-columnHeader": { border: "none " },
                  "& .MuiDataGrid-columnHeaders": { minHeight: "1rem !important", maxHeight: "2rem !important", background: "#153064", color: "#ffffff", fontSize: { xs: "0.7rem", md: "1rem", xl: "1.5rem" } },
                  "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                    display: "none",
                  },
                  "& .MuiDataGrid-virtualScrollerRenderZone": {
                    height: "30vh",
                    overflow: "auto"
                  },
                  "& .MuiDataGrid-columnHeaders": {width: "fit-content"},
                  scrollbarWidth: "0px",
                  "& .MuiDataGrid-scrollbar": {
                    display: "none",
                    width: "0px !important",
                    height: "0px !important"
                  },
                  "& .MuiDataGrid-container--bottom": {
                    display: "none"
                  },
                  "& .MuiDataGrid-cellContent": {
                    fontSize: { xs: "0.5rem", md: "0.7rem", lg: "0.8rem", xl: "1.2rem" }
                  },
                  borderRadius: "0.7rem"
                }}
              />
            </Grid>
          </Grid>
        ) : (
          <div
            className={Styles.profilecontent}
            style={{
              display: "flex",
              paddingBottom: "4%",
              justifyContent: "center",
              overflow: "auto",
              marginTop: "1rem",
              width: "100% !important",
              height: "80% !important",
            }}
          >
            <Paper
              elevation={3}
              style={{
                backgroundImage: "linear-gradient(#69B8F41A, #FFFFFF1A )",
                display: "flex",
                justifyContent: "center",
                height: "100%",
                width: "60%",
                "::-webkit-scrollbar": { display: "none", width: "none" },
                paddingBottom: "0%",
              }}
            >
              <Grid className={Styles.icon} container spacing={2} sx={{margin: "0"}}>
                <Grid
                  item
                  xs={12}
                  style={{
                    background: "linear-gradient(#B9D3E9, #E8EEF3 )",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0rem",
                    flexDirection: "column",
                    margin: "0"
                  }}
                >
                  <AccountCircle
                    style={{
                      color: "#154063",
                      fontSize: 100,
                      marginTop: "0.5rem",
                    }}
                  />
                  <h1 style={{ height: "30%", marginTop: "0" }}>
                    User Profile
                  </h1>
                </Grid>
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    // marginLeft: "16px",
                    paddingTop: "0.5rem",
                    justifyContent: "center",
                    flexDirection: "row",
                    overflow: "scroll",
                    "::-webkit-scrollbar": { display: "none", width: "none" },
                    scrollbarWidth: "none",
                  }}
                  container
                  xs={12}
                >
                  <div
                    style={{
                      width: "60%",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        gap: "0.2rem",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <p
                          style={{
                            color: " #154063",
                            fontSize: "1rem",
                            fontWeight: "bold",
                          }}
                        >
                          User Type:
                        </p>
                      </div>
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          justifyContent: "start",
                        }}
                      >
                        <p style={{ fontSize: "1rem" }}>{user.userType}</p>
                      </div>
                    </Grid>
                    {/* <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        gap: "0.2rem",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <p
                          style={{
                            color: " #154063",
                            fontSize: "1rem",
                            fontWeight: "bold",
                          }}
                        >
                          Username:
                        </p>
                      </div>
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          justifyContent: "start",
                        }}
                      >
                        <p style={{ fontSize: "1rem" }}>{user.principalName}</p>
                      </div>
                    </Grid> */}
                    {user.userType == "SEBI" ? (
                      <Grid
                        item
                        xs={12}
                        style={{
                          display: "flex",
                          gap: "0.2rem",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            width: "50%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <p
                            style={{
                              color: " #154063",
                              fontSize: "1rem",
                              fontWeight: "bold",
                            }}
                          >
                            Fund Access:
                          </p>
                        </div>
                        <div
                          style={{
                            width: "50%",
                            display: "flex",
                            justifyContent: "start",
                          }}
                        >
                          <p style={{ fontSize: "1rem" }}>{user.email}</p>
                        </div>
                      </Grid>
                    ) : (
                      <Grid
                        item
                        xs={12}
                        style={{
                          display: "flex",
                          gap: "0.2rem",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            width: "50%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <p
                            style={{
                              color: " #154063",
                              fontSize: "1rem",
                              fontWeight: "bold",
                            }}
                          >
                           {user.userType==='APMII'?"Name:":"PMS:"} 
                          </p>
                        </div>
                        <div
                          style={{
                            width: "50%",
                            display: "flex",
                            justifyContent: "start",
                          }}
                        >
                          <p style={{ fontSize: "1rem" }}>{user.userType==='APMII'?user.apmiiname:user.pmsName}</p>
                        </div>
                      </Grid>
                    )}

                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        gap: "0.2rem",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <p
                          style={{
                            color: " #154063",
                            fontSize: "1rem",
                            fontWeight: "bold",
                          }}
                        >
                          APMI Id:
                        </p>
                      </div>
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          justifyContent: "start",
                          overflow: "scroll",
                          "::-webkit-scrollbar": {
                            display: "none",
                            width: "none",
                          },
                          scrollbarWidth: "none",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "1rem",
                            overflow: "scroll",
                            scrollbarWidth: "none",
                          }}
                        >
                          {user.email}
                        </p>
                      </div>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </Paper>
          </div>
        )}
      </div>
    </>
  );
};

export default Profile;